var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "star-login" }, [
    _vm.isShowBack
      ? _c("a", { staticClass: "back", on: { click: _vm.back } }, [
          _c("img", {
            attrs: {
              src:
                "https://lf26-static.bytednsdoc.com/obj/eden-cn/lmgoeh7bfupevhpe/login-production/back.png",
              alt: "<"
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("返回")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("img", {
      staticClass: "login-bg",
      attrs: {
        src:
          "https://lf3-static.bytednsdoc.com/obj/eden-cn/lmgoeh7bfupevhpe/login-production/login-v2.png",
        alt: "login-bg"
      }
    }),
    _vm._v(" "),
    _c("section", { staticClass: "login-container", class: _vm.currentClass }, [
      _c(
        "section",
        { staticClass: "login-tab" },
        [
          _vm._l(_vm.tabConfig.list, function(item) {
            return [
              item
                ? _c(
                    "p",
                    {
                      key: item.value,
                      staticClass: "tab-item",
                      class: [
                        { active: item.value === _vm.tabConfig.choose.value }
                      ],
                      on: {
                        click: function($event) {
                          return _vm.switchClick(item)
                        }
                      }
                    },
                    [_vm._v("\n          " + _vm._s(item.key) + "\n        ")]
                  )
                : _vm._e()
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.isShowtips
        ? _c("section", { staticClass: "login-tips" }, [
            _vm._v("\n      " + _vm._s(_vm.loginTips) + "\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isMcn && _vm.currentPanel === _vm.PanelType.login
        ? _c(
            "a",
            {
              staticClass: "mcn-tips",
              attrs: {
                href: "/pages/help-center/mcn/article/detail/109107",
                target: "_blank"
              }
            },
            [_vm._v("\n      还没有注册？点这里看看\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("section", { staticClass: "login-sdk", attrs: { id: "login-sdk" } })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }